import React,{useEffect} from 'react';
import Select from 'react-select';
import {useField} from 'formik';

function SelectField(props) {
  const [field, state, {setValue, setTouched}] = useField(props.field.name);

  const onChange = (e,name,fieldIndex) => {
    
    props.customChange({value:e.value,name:name,fieldIndex:fieldIndex})
    
    
  };

  

  // useEffect(() => {

  //   setValue(props.value)

  // }, []);

const customStyles = {
  option: (provided, state) => ({
    ...provided,
   
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
 
}



  return (
    <>
    

    


    <Select {...props}  

    defaultValue={props.options.find((option) => option.value == props.value)}
    value={props.options.find((option) => option.value === props.value)}
    
    placeholder={props.placeholder}
     classNamePrefix={'react-select'}
    onChange={(e) => onChange(e,props.field.name,props.fieldIndex)} onBlur={setTouched}/>
    </>
  );
}

export default SelectField;